import { Link } from "@reach/router";
import styled from "styled-components";

export default styled(Link)`
  text-decoration: none;
`;
